import { Injectable }             from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
}                                 from '@angular/router';
import { Observable, of, EMPTY }  from 'rxjs';
import { mergeMap, take }         from 'rxjs/operators';
 
import { DataService } from '../services/data/data.service';
import { OrderModel } from '../models/order.model';
 
@Injectable({
  providedIn: 'root',
})

export class AllMyOrdersResolverService implements Resolve<OrderModel[]> {

  constructor(private dataService: DataService) {
  }
 
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<OrderModel[]> | Observable<never> {
    let id = route.paramMap.get('profileId');
    return this.dataService.getAllMyOrders(id).pipe(
        take(1),
        mergeMap(item => {
          if (item) {
            return of(item);
          } else { // id not found
            return EMPTY;
          }
        })
    );
  }
}